<template>
  <div class="myAccount">
    <div class="balance-box">
      <div class="balance-wrap">
        <div class="balance-amount">
          <div class="balance-info">
            <div class="balance-num">{{ balance }}</div>
            <div class="balance-desc">可提现余额(元)</div>
          </div>

          <div
            class="balance-info"
            style="margin-left: 16px"
          >
            <div class="balance-num">{{ redPacketNeedAuditAmountTotal }}</div>
            <div class="balance-desc">待审金额(元)</div>
          </div>
        </div>
        <!-- 当余额=0时，隐藏按钮 -->
        <div
          class="balance-button"
          @click="withdrawClickHandle"
          v-if="balance"
        >
          去微信小程序提现
        </div>
      </div>
    </div>

    <div>
      <van-tabs
        color="#3399FF"
        @change="changeActive"
        v-model="active"
      >
        <van-tab
          title="红包明细"
          name="1"
        >
          <div class="tabs-content">
            <div class="red-packet-tips">
              待订单凭证审核通过后可提现，若凭证不全退回订单则红包也会退回
            </div>
            <van-pull-refresh
              v-model="loading"
              @refresh="onRefresh"
            >
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoadMore"
              >
                <div v-if="redPacketDistributeList.length > 0">
                  <div
                    v-for="(item, index) in redPacketDistributeList"
                    :key="index"
                  >
                    <div class="record-card">
                      <redpacketCard :record="item" />
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="blank-wrap"
                >
                  <Blank />
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab
          title="提现记录"
          name="2"
        >
          <div class="tabs-content">
            <van-pull-refresh
              v-model="loading"
              @refresh="onRefresh"
            >
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoadMore"
              >
                <div v-if="withdrawList.length > 0">
                  <div
                    v-for="(item, index) in withdrawList"
                    :key="index"
                  >
                    <div class="record-card">
                      <withdrawCard :record="item" />
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="blank-wrap"
                >
                  <Blank />
                </div>
              </van-list>
            </van-pull-refresh>

          </div>
        </van-tab>

        <van-tab
          title="收支明细"
          name="3"
        >
          <div class="tabs-content">
            <van-pull-refresh
              v-model="loading"
              @refresh="onRefresh"
            >
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoadMore"
              >
                <div v-if="grantList.length > 0">
                  <div
                    v-for="(item, index) in grantList"
                    :key="index"
                  >
                    <div class="record-card">
                      <incomeCard :record="item" />
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="blank-wrap"
                >
                  <Blank />
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import withdrawCard from './components/withdraw-card.vue';
import redpacketCard from './components/redpacket-card.vue';
import jsApi from '@/common/jsApi';
import { cashAccountDetail } from '@/common/apiGeneral.js';
import incomeCard from './components/income-card.vue';
import Blank from '@/components/blank.vue';

export default {
  components: {
    withdrawCard,
    redpacketCard,
    incomeCard,
    Blank
  },
  mounted() {},
  data() {
    return {
      active: '1',
      balance: 0,
      redPacketNeedAuditAmountTotal: 0,
      detail: null,
      redPacketDistributeList: [],
      withdrawList: [],
      grantList: [],
      account: null,
      loading: false,
      finished: true,
      pageNum: 1,
      pageSize: 10,
      tabsOptions: { '1': 'redPacket', '2': 'withdraw', '3': 'grant' }
    };
  },
  created() {
    this.getCashAccountDetail(this.active);
    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {};
  },
  methods: {
    withdrawClickHandle() {
      jsApi.launchMiniProgram();
      console.log('发送桥接接口');
    },
    changeActive() {
      // 切换页签，请求过后，不用请求了
      if (this.active === '1') {
        if (this.redPacketDistributeList.length < 1) {
          this.pageNum = 1;
          this.getCashAccountDetail(this.active);
        }
      } else if (this.active === '2') {
        if (this.withdrawList.length < 1) {
          this.pageNum = 1;
          this.getCashAccountDetail(this.active);
        }
      } else {
        if (this.grantList.length < 1) {
          this.pageNum = 1;
          this.getCashAccountDetail(this.active);
        }
      }
    },
    onLoadMore() {
      this.pageNum++;
      if (this.active === '1') {
        this.getCashAccountDetail(this.active);
      } else if (this.active === '2') {
        this.getCashAccountDetail(this.active);
      } else {
        this.getCashAccountDetail(this.active);
      }
    },
    onRefresh() {
      this.pageNum = 1;
      this.finished = false;
      if (this.active === '1') {
        this.redPacketDistributeList = [];
        this.getCashAccountDetail(this.active);
      } else if (this.active === '2') {
        this.withdrawList = [];
        this.getCashAccountDetail(this.active);
      } else {
        this.grantList = [];
        this.getCashAccountDetail(this.active);
      }
    },
    async getCashAccountDetail(type) {
      if (this.pageNum == 1) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }

      try {
        this.loading = true;
        this.finished = true;
        const tab = this.tabsOptions[type];
        const res = await cashAccountDetail({ pageNum: this.pageNum,
                                              pageSize: 10, tabs: [tab] });
        if (res) {
          this.balance = res.canWithdrawBalance || 0;
          this.redPacketNeedAuditAmountTotal =
            res.redPacketNeedAuditAmountTotal || 0;
          this.detail = res;
          if (type === '1') {
            const redPacketDistributeRes = res.redPacketDistributeList || {};
            const list = redPacketDistributeRes.list || [];
            this.redPacketDistributeList = [...this.redPacketDistributeList, ...list];
            this.finished = this.redPacketDistributeList.length >= redPacketDistributeRes.total;
          } else if (type === '2') {
            const withdrawRes = res.withdrawList || {};
            const list = withdrawRes.list || [];
            this.withdrawList = [...this.withdrawList, ...list];
            this.finished = this.withdrawList.length >= (withdrawRes.total || 0);
          } else {
            const grantRes = res.grantList || {};
            const list = grantRes.list || [];
            this.grantList = [...this.grantList, ...list];
            this.finished = this.grantList.length >= (grantRes.total || 0);
          }
        } else {
          this.finished = true;
        }
        this.loading = false;
        this.$toast.clear();
      } catch (error) {
        this.loading = false;
        this.finished = true;
        this.$toast.clear();
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.myAccount {
  height: 100%;
  background: #f2f3f5;
  font-size: 0.24rem;
}
.balance-box {
  background: #ffffff;
  padding: 12px 12px 0 12px;

  .balance-wrap {
    height: 140px;
    background: #3399ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    flex: 1;

    .balance-amount {
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      align-items: center;

      margin-top: 24px;
      .balance-info {
        width: 150px;
        text-align: center;
        .balance-num {
          font-family: PingFangSC-Medium;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 500;
          height: 33px;
          line-height: 33px;
        }
        .balance-desc {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          opacity: 0.7;
          color: #ffffff;
          letter-spacing: 0;
          font-weight: 400;
          margin-top: 2px;
          height: 17px;
          line-height: 17px;
        }
      }
    }

    .balance-button {
      width: 120px;
      height: 32px;
      background: #ffffff;
      border-radius: 8px;
      margin-top: 16px;

      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #1a5fa5;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      line-height: 32px;
    }
  }
}

.tabs-content {
  background-color: #f2f3f5;
  min-height: calc(100vh - 200px);
  padding: 12px;
  font-family: PingFangSC-Regular;
  font-size: 14px;

  .red-packet-tips {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #f32222;
    font-weight: 400;
    padding-bottom: 12px;
  }
  .record-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;

    .blank-wrap {
      padding-top: 90px;
    }
  }
}
</style>
